import { MutationFunction, useQuery } from '@apollo/client'
import { Autocomplete, TextField } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import UpdatedText from 'shared/components/UpdatedText/UpdatedText'
import { GetStartDateOptions } from 'shared/graphql/startDates.gql'

interface StartDateProps {
    preferredStartDate?: string[]
    handleUpdate: MutationFunction<any, any>
    candidateId?: string
    updatedAt?: string
    updatedBy?: string
}

const StartDate: FC<StartDateProps> = ({
    preferredStartDate,
    updatedAt,
    updatedBy,
    candidateId,
    handleUpdate,
}) => {
    const [startDates, setStartDates] = useState<string[] | undefined>(
        preferredStartDate
    )
    const { data } = useQuery(GetStartDateOptions)

    useEffect(() => {
        setStartDates(preferredStartDate)
    }, [preferredStartDate])

    return (
        <>
            <Autocomplete
                options={data?.candidateStartDates || []}
                renderInput={(params) => <TextField {...params} />}
                multiple
                value={startDates}
                onChange={(event, value, reason) => {
                    setStartDates(value)
                    handleUpdate({
                        variables: {
                            candidateId,
                            startDates: value,
                        },
                    })
                }}
            />

            <UpdatedText updatedAt={updatedAt} updatedBy={updatedBy} />
        </>
    )
}

export default StartDate
